import { EMPLOYMENT_TYPE } from '../../../utils/profileFormMaps';

export function isSalariedEmployee(employee) {
    return (
        String(employee?.employmentType || '').toLowerCase() ===
        EMPLOYMENT_TYPE.SALARIED
    );
}

export function validateCreateTaskForm(
    taskForm,
    { activeEmployeeCount = 0, selectedEmployee = null } = {},
) {
    const errors = {};

    if (!String(taskForm.title || '').trim()) {
        errors.title = 'Task title is required.';
    } else if (String(taskForm.title).trim().length < 3) {
        errors.title = 'Task title must be at least 3 characters.';
    }

    if (!String(taskForm.summary || '').trim()) {
        errors.summary = 'Summary is required.';
    } else if (String(taskForm.summary).trim().length < 10) {
        errors.summary = 'Summary must be at least 10 characters.';
    }

    if (!taskForm.employeeId) {
        errors.employeeId =
            activeEmployeeCount === 0
                ? 'Add an active employee before creating a task.'
                : 'Select an employee to assign this task.';
    }

    const salaried = isSalariedEmployee(selectedEmployee);

    if (!salaried) {
        const amountRaw = String(taskForm.amount ?? '').trim();
        if (!amountRaw) {
            errors.amount = 'Payment amount is required.';
        } else {
            const amountNum = Number(amountRaw);
            if (!Number.isFinite(amountNum) || amountNum <= 0) {
                errors.amount = 'Enter a valid amount greater than zero.';
            }
        }
    }

    if (taskForm.dueDate) {
        const due = new Date(taskForm.dueDate);
        if (Number.isNaN(due.getTime())) {
            errors.dueDate = 'Enter a valid due date.';
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (due < today) {
                errors.dueDate = 'Due date cannot be in the past.';
            }
        }
    }

    return errors;
}

export function hasCreateTaskFormErrors(errors) {
    return Object.keys(errors || {}).length > 0;
}
